<template>
    <div class="about-initiative-form5">
        <slot name="how-register-modal"></slot>

        <div class="edit-info" v-if="getEditionMode">
            <b-button
                :variant="getIsDarkTheme ? 'outline-light' : 'outline-dark'"
                size="sm"
                @click="changeStatusDisabled(false)"
            >
                Editar informações
            </b-button>
        </div>

        <b-form @submit.stop.prevent="onSubmit" novalidate>
            <div class="row">
                <b-form-group label="Colaboradores" label-for="employeesNumber" class="col-md-4">
                    <b-form-select
                        id="employeesNumber"
                        name="employeesNumber"
                        v-model="form.employeesNumber.selected"
                        :options="form.employeesNumber.options"
                        :disabled="getIsDisabled"
                        v-if="
                            !isPlatform ||
                                (isPlatform &&
                                    getAuthorizationData &&
                                    getAuthorizationData['id_numero_colaborador'].value)
                        "
                    ></b-form-select>

                    <NoAuthorizationMsgPP
                        v-if="
                            isPlatform && getAuthorizationData && !getAuthorizationData['id_numero_colaborador'].value
                        "
                    />
                </b-form-group>

                <b-form-group
                    label="Porcentagem de colaboradoras"
                    label-for="womenQuantity"
                    class="col-md-8"
                >
                    <b-form-select
                        id="womenQuantity"
                        name="womenQuantity"
                        v-model="form.womenQuantity.selected"
                        :options="form.womenQuantity.options"
                        :disabled="getIsDisabled"
                        v-if="
                            !isPlatform ||
                                (isPlatform &&
                                    getAuthorizationData &&
                                    getAuthorizationData['id_percentual_colaborador'].value)
                        "
                    ></b-form-select>

                    <NoAuthorizationMsgPP
                        v-if="
                            isPlatform &&
                                getAuthorizationData &&
                                !getAuthorizationData['id_percentual_colaborador'].value
                        "
                    />
                </b-form-group>
            </div>

            <b-form-group label="Sua iniciativa já foi acelerada?" label-for="hadAcceleration">
                <b-form-radio-group
                    id="hadAcceleration"
                    name="hadAcceleration"
                    v-model="form.hadAcceleration.selected"
                    :options="form.hadAcceleration.options"
                    stacked
                    :disabled="getIsDisabled"
                    v-if="
                        !isPlatform ||
                            (isPlatform && getAuthorizationData && getAuthorizationData['possou_tipo_acelerador'].value)
                    "
                ></b-form-radio-group>

                <NoAuthorizationMsgPP
                    v-if="isPlatform && getAuthorizationData && !getAuthorizationData['possou_tipo_acelerador'].value"
                />
            </b-form-group>

            <b-form-group
                label="Resposta sobre o Interesse em fazer parte da plataforma"
                label-for="interests"
                class="required"
            >
                <b-form-checkbox-group
                    id="interests"
                    name="interests"
                    v-model="$v.form.interests.selected.$model"
                    :options="form.interests.options"
                    value-field="item"
                    text-field="text"
                    :state="validateState('interests')"
                    :disabled="getIsDisabled"
                    v-if="
                        !isPlatform ||
                            (isPlatform && getAuthorizationData && getAuthorizationData['interesse_em_ppp'].value)
                    "
                ></b-form-checkbox-group>

                <NoAuthorizationMsgPP
                    v-if="isPlatform && getAuthorizationData && !getAuthorizationData['interesse_em_ppp'].value"
                />

                <b-form-invalid-feedback :state="validateState('interests')">
                    Campo obrigatório
                </b-form-invalid-feedback>
            </b-form-group>

            <b-form-group class="col-md-6 others-field" v-if="form.interests.selected.includes(13)">
                <b-form-input
                    id="others"
                    name="others"
                    v-model="form.others"
                    placeholder="Digite aqui"
                    :disabled="getIsDisabled"
                ></b-form-input>
            </b-form-group>

            <b-form-group
                label="Ligação a partido político"
                label-for="politicalConnection"
                class="required"
            >
                <b-form-radio-group
                    id="politicalConnection"
                    name="politicalConnection"
                    v-model="$v.form.politicalConnection.selected.$model"
                    :options="form.politicalConnection.options"
                    :state="validateState('politicalConnection')"
                    stacked
                    :disabled="getIsDisabled"
                    v-if="
                        !isPlatform ||
                            (isPlatform && getAuthorizationData && getAuthorizationData['ligada_algum_partido'].value)
                    "
                ></b-form-radio-group>

                <NoAuthorizationMsgPP
                    v-if="isPlatform && getAuthorizationData && !getAuthorizationData['ligada_algum_partido'].value"
                />

                <b-form-invalid-feedback :state="validateState('politicalConnection')">
                    Campo obrigatório
                </b-form-invalid-feedback>
            </b-form-group>

            <b-form-group
                label="Afiliação com igreja"
                label-for="churchConnection"
                class="required"
            >
                <b-form-radio-group
                    id="churchConnection"
                    name="churchConnection"
                    v-model="$v.form.churchConnection.selected.$model"
                    :options="form.churchConnection.options"
                    :state="validateState('churchConnection')"
                    stacked
                    :disabled="getIsDisabled"
                    v-if="
                        !isPlatform ||
                            (isPlatform && getAuthorizationData && getAuthorizationData['afiliacao_algum_igreja'].value)
                    "
                ></b-form-radio-group>

                <NoAuthorizationMsgPP
                    v-if="isPlatform && getAuthorizationData && !getAuthorizationData['afiliacao_algum_igreja'].value"
                />

                <b-form-invalid-feedback :state="validateState('churchConnection')">
                    Campo obrigatório
                </b-form-invalid-feedback>
            </b-form-group>

            <hr class="line" />

            <div class="footer-buttons">
                <b-button
                    :variant="'secondary'"
                    class="radius-6"
                    @click="$router.push({ name: 'AboutInitiativeForm4' })"
                    v-if="!showFooterButtons"
                    >Voltar</b-button
                >

                <b-button type="submit" :variant="'primary'" class="radius-6 submit" v-if="!showFooterButtons"
                    >Próximo</b-button
                >

                <div class="display-initial" v-if="showFooterButtons">
                    <b-button :variant="'secondary'" @click="changeRegisterForm('AboutInitiativeForm4')"
                        >Voltar</b-button
                    >

                    <b-button
                        :variant="'primary'"
                        @click="
                            changeRegisterForm(
                                getProfileId === 2 && initiative.interesse_em_ppp.includes(11)
                                    ? 'AboutInitiativeForm7'
                                    : getProfileId === 2 && !initiative.interesse_em_ppp.includes(11)
                                    ? 'AboutInitiativeForm9'
                                    : getProfileId === 3
                                    ? 'AboutInitiativeForm12'
                                    : 'AboutInitiativeForm6'
                            )
                        "
                    >
                        Próximo
                    </b-button>
                </div>

                <b-button
                    variant="success"
                    @click=";(isUpdate = true), onSubmit()"
                    v-if="getEditionMode && !getIsDisabled"
                >
                    Salvar
                </b-button>
            </div>
        </b-form>

        <DangerModalPP ref="warningModal" :message="message" />
    </div>
</template>

<script>
import axios from 'axios'
import { mapActions } from 'vuex'
import DangerModalPP from '@/ui/modal/danger-modal-pp/DangerModalPP'
import { required } from 'vuelidate/lib/validators'
import { AboutInitiativeApi } from '../../api/about-initiative'
import { AuthorizationApi } from '../../api/admin/authorization-api'
import NoAuthorizationMsgPP from '@/ui/no-authorization-msg-pp/NoAuthorizationMsgPP'

const authorizationApi = new AuthorizationApi()
const aboutInitiativeApi = new AboutInitiativeApi()

export default {
    components: { DangerModalPP, NoAuthorizationMsgPP },
    props: {
        disabled: {
            type: Boolean,
            default: false
        },
        editionMode: {
            type: Boolean,
            default: false
        },
        isPlatform: {
            type: Boolean,
            default: false
        },
        receiveData: {
            default: null
        },
        showFooterButtons: {
            type: Boolean,
            default: false
        },
        userIdLogged: {
            default: null
        },
        allowAuthorization: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            isDisabled: null,
            progress: 30.47,
            initiative: null,
            message: null,
            isUpdate: false,
            authorizationData: null,
            form: {
                employeesNumber: {
                    selected: null,
                    options: [{ value: null, text: 'Selecione' }]
                },
                womenQuantity: {
                    selected: null,
                    options: [{ value: null, text: 'Selecione' }]
                },
                hadAcceleration: {
                    selected: null,
                    options: [
                        { text: 'Sim', value: 1 },
                        { text: 'Não', value: 0 }
                    ]
                },
                politicalConnection: {
                    selected: null,
                    options: [
                        { text: 'Sim', value: 1 },
                        { text: 'Não', value: 0 }
                    ]
                },
                churchConnection: {
                    selected: null,
                    options: [
                        { text: 'Sim', value: 1 },
                        { text: 'Não', value: 0 }
                    ]
                },
                interests: {
                    selected: [],
                    options: [
                        { text: 'Encontrar iniciativas para apoiar', item: 1, value: 1 },
                        { text: 'Receber doação de bens móveis e imóveis', item: 3, value: 3 },
                        { text: 'Expandir minha rede', item: 2, value: 2 },
                        { text: 'Receber consultoria especializada (planejamento, captação, etc.)', item: 4, value: 4 },
                        { text: 'Participar de cursos e eventos', item: 5, value: 5 },
                        { text: 'Receber apoio para realização de pesquisa', item: 6, value: 6 },
                        { text: 'Passar por processo de aceleração', item: 7, value: 7 },
                        { text: 'Vender produtos', item: 8, value: 8 },
                        { text: 'Realizar parcerias', item: 9, value: 9 },
                        { text: 'Vender serviços', item: 10, value: 10 },
                        { text: 'Receber aporte financeiro', item: 11, value: 11 },
                        { text: 'Atrair voluntários', item: 12, value: 12 },
                        { text: 'Outros (especifique)', item: 13, value: 13 }
                    ]
                },
                others: null
            }
        }
    },
    validations: {
        form: {
            interests: {
                selected: { required }
            },
            politicalConnection: {
                selected: { required }
            },
            churchConnection: {
                selected: { required }
            }
        }
    },
    methods: {
        ...mapActions(['setIsLoading', 'setCurrentFormPlatform', 'setProgress']),
        validateState(nameField) {
            const { $dirty, $error } = this.$v.form[nameField]
            return $dirty ? !$error : null
        },
        fetchRead() {
            const data = this.receiveData
            this.initiative = data

            this.form.employeesNumber.selected = data.id_numero_colaborador
            this.form.womenQuantity.selected = data.id_percentual_colaborador
            this.form.hadAcceleration.selected = data.possou_tipo_acelerador
            this.form.politicalConnection.selected = data.ligada_algum_partido
            this.form.churchConnection.selected = data.afiliacao_algum_igreja
            this.form.interests.selected = data.interesse_em_ppp || []
            this.form.others = data.outro

            this.setIsLoading(true)

            axios
                .all([aboutInitiativeApi.getCollaboratorNumber(), aboutInitiativeApi.getEmployeePercentage()])
                .then(response => {
                    this.form.employeesNumber.options.push(
                        ...response[0].data.map(item => ({ value: item.id, text: item.numero_colaborador }))
                    )

                    this.form.womenQuantity.options.push(
                        ...response[1].data.map(item => ({ value: item.id, text: item.percentual_colaborador }))
                    )

                    this.fetchAuthorization()
                })
                .catch(error => {
                    this.message = error.response.data.message
                    this.$refs.warningModal.showModal()
                })
                .finally(() => {
                    this.filterData()
                    this.setIsLoading(false)
                })
        },
        fetch() {
            this.setIsLoading(true)

            axios
                .all([
                    aboutInitiativeApi.getAboutInitiative(),
                    aboutInitiativeApi.getCollaboratorNumber(),
                    aboutInitiativeApi.getEmployeePercentage()
                ])
                .then(response => {
                    const data = response[0].data.data
                    if (data !== null) {
                        this.initiative = data
                        this.form.employeesNumber.selected = data.id_numero_colaborador
                        this.form.womenQuantity.selected = data.id_percentual_colaborador
                        this.form.hadAcceleration.selected = data.possou_tipo_acelerador
                        this.form.politicalConnection.selected = data.ligada_algum_partido
                        this.form.churchConnection.selected = data.afiliacao_algum_igreja
                        this.form.interests.selected = data.interesse_em_ppp || []
                        this.form.others = data.outro
                    }

                    this.form.employeesNumber.options.push(
                        ...response[1].data.map(item => ({ value: item.id, text: item.numero_colaborador }))
                    )

                    this.form.womenQuantity.options.push(
                        ...response[2].data.map(item => ({ value: item.id, text: item.percentual_colaborador }))
                    )
                })
                .catch(error => {
                    this.message = error.response.data.message
                    this.$refs.warningModal.showModal()
                })
                .finally(() => this.setIsLoading(false))
        },
        onSubmit(event) {
            this.$v.form.$touch()
            if (this.$v.form.$anyError) {
                return
            }

            const currentProgress = this.getProgress < this.progress ? this.progress : this.getProgress
            const data = {
                ...this.initiative,
                id_numero_colaborador: this.form.employeesNumber.selected,
                id_percentual_colaborador: this.form.womenQuantity.selected,
                possou_tipo_acelerador: this.form.hadAcceleration.selected,
                ligada_algum_partido: this.form.politicalConnection.selected,
                afiliacao_algum_igreja: this.form.churchConnection.selected,
                interesse_em_ppp: this.form.interests.selected,
                outro: this.form.others,
                percentual: currentProgress
            }

            this.setIsLoading(true)
            const request = this.isUpdate
                ? aboutInitiativeApi.updateAboutInitiative(data)
                : aboutInitiativeApi.nextAboutInitiative(data)

            request
                .then(response => {
                    this.setProgress(data.percentual)
                    this.initiative = data

                    if (this.isUpdate) {
                        this.changeStatusDisabled(true)
                    } else {
                        this.$router.push({
                            name:
                                this.getProfileId === 2 && this.initiative.interesse_em_ppp.includes(11)
                                    ? 'AboutInitiativeForm7'
                                    : this.getProfileId === 2 && !this.initiative.interesse_em_ppp.includes(11)
                                    ? 'AboutInitiativeForm9'
                                    : this.getProfileId === 3
                                    ? 'AboutInitiativeForm12'
                                    : 'AboutInitiativeForm6'
                        })
                    }
                })
                .catch(error => {
                    this.message = error.response.data.message
                    this.$refs.warningModal.showModal()
                })
                .finally(() => this.setIsLoading(false))
        },
        changeStatusDisabled(status) {
            this.isDisabled = status
        },
        changeRegisterForm(formName) {
            this.setCurrentFormPlatform(formName)
            this.scrollBehavior()
        },
        scrollBehavior(to, from, savedPosition) {
            const ele = document.getElementById('top-register-painel')
            return window.scrollTo({
                top: ele.offsetTop,
                behavior: 'smooth'
            })
        },
        fetchAuthorization() {
            if (this.allowAuthorization) {
                this.setIsLoading(true)

                authorizationApi
                    .getAboutInitiative(this.userIdLogged)
                    .then(response => {
                        if (response.data.data === null || response.data.data.length === 0) {
                            this.authorizationData = null
                        } else {
                            this.authorizationData = response.data.data
                        }
                    })
                    .catch(error => {
                        this.message = error.response.data.message
                        this.$refs.warningModal.showModal()
                    })
                    .finally(() => {
                        this.setIsLoading(false)
                    })
            }
        },
        filterData() {
            if (this.receiveData) {
                this.form.interests.options = this.form.interests.options.filter(x =>
                    this.form.interests.selected.includes(x.value)
                )

                this.form.hadAcceleration.options = this.form.hadAcceleration.options.filter(
                    x => Number(this.form.hadAcceleration.selected) === x.value
                )

                this.form.politicalConnection.options = this.form.politicalConnection.options.filter(
                    x => Number(this.form.politicalConnection.selected) === x.value
                )

                this.form.churchConnection.options = this.form.churchConnection.options.filter(
                    x => Number(this.form.churchConnection.selected) === x.value
                )
            }
        }
    },
    computed: {
        getEditionMode() {
            return this.editionMode
        },
        getIsDisabled() {
            return this.isDisabled
        },
        getProgress() {
            return this.$store.state.progress
        },
        getIsDarkTheme() {
            return this.$store.state.darkTheme
        },
        getProfileId() {
            return this.$store.state.profileId
        },
        getAuthorizationData() {
            return this.authorizationData
        }
    },
    created() {
        this.isDisabled = this.disabled
        this.receiveData === null ? this.fetch() : this.fetchRead()
    }
}
</script>

<style scope src="./AboutInitiativeForm5-light-theme.css"></style>



// WEBPACK FOOTER //
// src/components/register-about-initiative-forms/AboutInitiativeForm5.vue